module.exports = __webpack_public_path__ + "static/media/support.e606d02a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/support.svg
// module id = 1624
// module chunks = 0